import { render, staticRenderFns } from "./header.vue?vue&type=template&id=5351955b&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=5351955b&prod&lang=less&scoped=true"
import style1 from "./header.vue?vue&type=style&index=1&id=5351955b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5351955b",
  null
  
)

export default component.exports